import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import withMobileDialog from "@material-ui/core/withMobileDialog";
import RecordPagination  from "../../utils/RecordsPagination";
import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
} from "@material-ui/core";
import {appHelpers} from "../../_helpers";

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Poppins', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  tableStyle: {
    padding: 0
  }
};

const RecordTableStructure = ({classes, records, pageIndex, findUser}) => (
    <Table className={classes.table} aria-labelledby="tableTitle">
        <TableHead className={classes.negativeColor} color="primary">
            <TableRow>
                <TableCell>S/N</TableCell>
                <TableCell>User</TableCell>
                <TableCell>Location</TableCell>
                <TableCell>Module</TableCell>
                <TableCell>Action</TableCell>
                <TableCell>IP Address</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Created Date</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {records.map((item, key) => {
                return (
                    <TableRow hover key={key}>
                        <TableCell className={'text-capitalize'}>
                            { pageIndex + key }
                        </TableCell>
                        <TableCell className={'text-capitalize'}>
                            { findUser(item.UserId) }
                        </TableCell>
                        <TableCell className={'text-capitalize'}>
                            { item.Location }
                        </TableCell>
                        <TableCell component="th">
                            {item.ModuleName}
                        </TableCell>
                        <TableCell component="th">
                            {item.ActionName}
                        </TableCell>
                        <TableCell component="th">
                            {item.IPAddress}
                        </TableCell>
                        <TableCell component="th" style={{textAlign: 'justify', width: '25%'}}>
                            {item.Description}
                        </TableCell>
                        <TableCell>{ appHelpers.formatDateSpecific(
                            item.CreatedDate,
                            "MMM DD, YYYY"
                        )}
                        </TableCell>
                    </TableRow>
                );
            })}
        </TableBody>
    </Table>
);

class FlightsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      flight: false
    };
  }

  handleClickOpen = (flight) => {
    this.setState({ open: true });
    this.setState({flight});
    this.props.fetchFlightPassengers(flight.Id);
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes,
        totalCounts, records,
         fetchMore, currentPage, pageSize,
         findUser
    } = this.props;
    const pageIndex = (pageSize * (currentPage - 1)) + 1;
    return (
      <div>
        <div className={classes.tableResponsive} style={{ overflowX: "auto" }}>
          <RecordPagination
              fetchMore={fetchMore}
              totalCount={totalCounts}
              pageSize={pageSize}
              currentPage={currentPage}
              target={
                  <RecordTableStructure
                      classes={classes}
                      records={records}
                      pageIndex={pageIndex}
                      findUser={findUser}
                  />
              }/>
        </div>
      </div>
    );
  }
}

export default withMobileDialog()(withStyles(styles)(FlightsTable));



// WEBPACK FOOTER //
// ./src/views/AuditTrail/RecordsTable.jsx